import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import * as Yup from "yup";
import { useFormik, Formik, Form, Field, ErrorMessage } from "formik";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Switch from "react-switch";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function InvestorDetail() {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = { width: "10em", whiteSpace: "nowrap" };
  const [loading, setLoading] = useState(true);
  const [wait, setWait] = useState(1000);
  const token = localStorage.getItem("auth_token");
  const [investisseursData, setInvestisseursData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState(history?.state?.usr?.active); // État pour contrôler l'affichage
  const [comments, setComments] = useState(""); // Commentaire
  const [nom, setNom] = useState(""); // Nom
  const [prenom, setPrenom] = useState(""); // Prenom
  const [dateNaissance, setDateNaissance] = useState(""); // date de naissance
  const [villeNaissance, setVilleNaissance] = useState(""); // ville de naissance
  const [depNaissance, setDepNaissance] = useState(""); // departement de naissance
  const [profession, setProfession] = useState(""); // profession
  const [adresse, setAdresse] = useState(""); // adresse
  // tableau adresse postales PP
  const [complement, setComplement] = useState(""); // complement
  const [codePostal, setCodePostal] = useState(""); // code postal
  const [ville, setVille] = useState(""); // ville
  const [telFixe, setTelFixe] = useState(""); // tel fixe
  // tableau adresse email
  const [email, setEmail] = useState("");
  // tableau numéros de téléphone
  const [numero, setNumero] = useState("");

  const [courrier, setCourrier] = useState(""); //Courrier
  const [titre, setTitre] = useState(""); // Titre
  // PM
  const [denomSocial, setDenomSocial] = useState(""); // Denomination social
  const [numeroRcs, setNumeroRcs] = useState(""); // Numéro RCS
  const [telephone, setTelephone] = useState(""); // Telephone
  const [fax, setFax] = useState(""); // Fax
  const [emailPm, setEmailPm] = useState(""); // email PM

  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/investisseurs/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.status);
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      // if (!response.ok) {
      //   localStorage.removeItem("auth_token");
      //   localStorage.removeItem("authUser");
      //   localStorage.removeItem("sideBar");
      //   history('/backoffice_test/login');
      //   window.location.reload(false);
      //   // throw new Error("Erreur lors de la récupération des données");
      //   // rediriger vers le login
      // }

      const investisseursData = await response.json();
      setInvestisseursData(investisseursData);
      setSelectedStatut(
        investisseursData?.detail_investisseur?.identification.Statut
      );
      setSelectedConseil(
        investisseursData?.detail_investisseur?.identification.Partenaire
      );
      setSelectedCourrier(
        investisseursData?.detail_investisseur?.identification.Courrier
      );
      setSelectedCsp(
        investisseursData?.detail_investisseur?.identification.Csp
      );
      if (investisseursData?.detail_investisseur?.identification.Type == "PP") {
        setNom(investisseursData?.detail_nom_investisseur?.identification.Nom);
        setPrenom(
          investisseursData?.detail_nom_investisseur?.identification.Prénom
        );
        setSelectedTitre(
          investisseursData?.detail_nom_investisseur?.identification.Titre
        );
        setSelectedSociete(
          investisseursData?.detail_nom_investisseur?.identification.Société
        );
        setDateNaissance(
          formatDateToFrench(
            investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
              "Date de naissance"
            ]
          )
        );
        setVilleNaissance(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Ville de naissance"
          ]
        );
        setDepNaissance(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Département de naissance"
          ]
        );
        setProfession(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Profession"
          ]
        );
        setSelectedSituationMatrimoniale(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Situation matrimoniale"
          ]
        );
        setFormAdressePostals(
          investisseursData?.detail_nom_investisseur?.adresses_postales
            ?.Adresses.data
        );
        setFormAdresseEmails(
          investisseursData?.detail_nom_investisseur?.adresses_email?.Emails
            .data
        );
        setFormNumeroTelephones(
          investisseursData?.detail_nom_investisseur?.numeros_de_telephone?.[
            "Téléphones"
          ].data
        );
      }
      if (investisseursData?.detail_investisseur?.identification.Type == "PM") {
        setFormAdressePostals(
          investisseursData?.detail_nom_investisseur?.adresses?.Adresses.data
        );
        setSelectedForme(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Forme juridique"
          ]
        );
        setSelectedPresidentPP(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Président (PP)"
          ]
        );
        setSelectedPresidentPM(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Président (PM)"
          ]
        );
        setSelectedDir(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Directeur Général"
          ]
        );
        setDenomSocial(
          investisseursData?.detail_nom_investisseur?.identification?.[
            "Dénomination sociale"
          ]
        );
        setNumeroRcs(
          investisseursData?.detail_nom_investisseur?.identification?.["N° RCS"]
        );
        setTelephone(
          investisseursData?.detail_nom_investisseur?.contact?.["Téléphone"]
        );
        setFax(investisseursData?.detail_nom_investisseur?.contact?.["Fax"]);
        setEmailPm(
          investisseursData?.detail_nom_investisseur?.contact?.["Email"]
        );
      }

      setComments(investisseursData?.detail_investisseur?.details.Commentaires);
      setTitre(
        investisseursData?.detail_nom_investisseur?.identification.Titre
      );
    } catch (error) {
      console.error(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/statut_investisseurs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((statut) => {
          setStatutData(statut);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Statut *******************************/

  /*************************   Conseil  *******************************/

  const [conseilData, setConseilData] = useState({ data: [] });
  const [selectedConseil, setSelectedConseil] = useState("");
  const renderConseilOptions = () => {
    return [
      {
        options: conseilData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleConseilChange = (e) => {
    setSelectedConseil(e);
  };
  const getConseil = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/partenaires`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((conseil) => {
          setConseilData(conseil);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Conseil *******************************/
  /*************************   Courrier  *******************************/
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  const courrierData = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const [selectedCourrier, setSelectedCourrier] = useState("");

  const [selectedYesNo, setSelectedYesNo] = useState("");
  const renderYesNoOptions = () => {
    return [
      <option key="" value=""></option>,
      ...courrierData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleYesNoChange = (e) => {
    setSelectedYesNo(e.target.value);
  };
  /*************************   END Courrier *******************************/
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [selectedTitre, setSelectedTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setSelectedTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  /*************************   Societe  *******************************/
  const [societeData, setSocieteData] = useState({ data: [] });
  const [selectedSociete, setSelectedSociete] = useState("");

  const renderSocieteOptions = () => {
    return [
      {
        options: societeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSocieteChange = (e) => {
    setSelectedSociete(e);
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Societe *******************************/
  /*************************   Csp  *******************************/
  const [cspData, setCspData] = useState({ data: [] });
  const [selectedCsp, setSelectedCsp] = useState("");
  const renderCspOptions = () => {
    return [
      <option key="" value=""></option>,
      ...cspData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleCspChange = (e) => {
    setSelectedCsp(e.target.value);
  };
  const getCsp = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/csps`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((csp) => {
          setCspData(csp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Csp *******************************/
  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [selectedSituationMatrimoniale, setSelectedSituationMatrimoniale] =
    useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSelectedSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  /*************************   TypesAdress  *******************************/
  const [typesAdressData, setTypesAdressData] = useState({ data: [] });

  const renderTypesAdressOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesAdressData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getTypesAdress = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_adresss`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesAdress) => {
          setTypesAdressData(typesAdress);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END TypesAdress *******************************/
  /*************************   TypesTelephone  *******************************/
  const [typesTelephoneData, setTypesTelephoneData] = useState({ data: [] });
  const renderTypesTelephoneOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesTelephoneData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getTypesTelephone = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_adresss`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesTelephone) => {
          setTypesTelephoneData(typesTelephone);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END TypesTelephone *******************************/

  /*************************   TypesEmail  *******************************/
  const [typesEmailData, setTypesEmailData] = useState({ data: [] });
  const renderTypesEmailOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesEmailData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };

  const getTypesEmail = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_emails`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesEmail) => {
          setTypesEmailData(typesEmail);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   END TypesEmail *******************************/

  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPayOptions = () => {
    const emptyOption = (
      <option key="empty" value="">
        Sélectionner une option
      </option>
    );

    return [
      emptyOption,
      ...payData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  /*************************   Formes juridiques         *******************************/
  const [formeJuridique, setFormeJuridique] = useState({ data: [] });
  const [selectedForme, setSelectedForme] = useState("");
  const renderFormeOptions = () => {
    return [
      {
        options: formeJuridique.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleFormeChange = (e) => {
    setSelectedForme(e);
  };
  const getFormeJuri = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/formes_juridiques`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((formeJuridique) => {
          setFormeJuridique(formeJuridique);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Formes juridiques         *******************************/

  /*************************   Président PM          *******************************/
  const [presidentData, setPresidentData] = useState({ data: [] });
  const [selectedPresidentPM, setSelectedPresidentPM] = useState("");
  const [selectedPresidentPP, setSelectedPresidentPP] = useState("");

  const renderPresidentOptions = () => {
    return [
      {
        options: presidentData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePresidentChange = (e) => {
    setSelectedPresidentPM(e);
  };
  const handlePresidentPPChange = (e) => {
    setSelectedPresidentPP(e);
  };
  const getPresident = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((president) => {
          setPresidentData(president);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END President         *******************************/

  /*************************   Directeur          *******************************/
  const [directeurData, setDirecteurData] = useState({ data: [] });
  const [selectedDir, setSelectedDir] = useState("");
  const renderDirecteurOptions = () => {
    return [
      {
        options: directeurData.data.map((dataItem) => ({
          label: dataItem.label,
          id: dataItem.id,
        })),
      },
    ];
  };
  const handleDirecteurChange = (e) => {
    setSelectedDir(e);
  };
  const getDirecteur = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/contacts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((directeur) => {
          setDirecteurData(directeur);
          setWait(0);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Directeur         *******************************/

  /******************************* HMF adresses postales *******************************************/
  const [formAdressePostals, setFormAdressePostals] = useState({});

  const onAddFormAdressePostal = () => {
    const modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals.push({
      index: modifiedAdressePostals.length + 1,
      id: null,
      principale: null,
      types_adress_id: null,
      adresse: null,
      complement: null,
      code_postal: null,
      ville: null,
      pay_id: null,
      tel_fixe: null,
    });
    setFormAdressePostals(modifiedAdressePostals);
  };

  const onDeleteFormAdressePostal = (id) => {
    var modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals = modifiedAdressePostals.filter(
      (x) => x["index"] !== id
    );
    setFormAdressePostals(modifiedAdressePostals);
  };
  /******************************* END HMF adresses postales *******************************************/

  /******************************* HMF adresses postales PM *******************************************/

  const onAddFormAdressePostalPM = () => {
    const modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals.push({
      index: modifiedAdressePostals.length + 1,
      id: null,
      siege: null,
      adresse: null,
      complement: null,
      code_postal: null,
      ville: null,
      pay_id: null,
      tel: null,
    });
    setFormAdressePostals(modifiedAdressePostals);
  };

  const onDeleteFormAdressePostalPM = (id) => {
    var modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals = modifiedAdressePostals.filter(
      (x) => x["index"] !== id
    );
    setFormAdressePostals(modifiedAdressePostals);
  };
  const handleInputChange = (index, field, value) => {
    console.log("ID:", index);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedAdressePostals = formAdressePostals.map((adressePostal) => {
      if (adressePostal.index === index) {
        return {
          ...adressePostal,
          [field]: value,
        };
      }
      return adressePostal;
    });

    setFormAdressePostals(modifiedAdressePostals);
  };
  /******************************* END HMF adresses postales *******************************************/
  /******************************* HMF adresses emails *******************************************/
  const [formAdresseEmails, setFormAdresseEmails] = useState({});

  const onAddFormAdresseEmail = () => {
    const modifiedAdresseEmails = [...formAdresseEmails];
    modifiedAdresseEmails.push({
      index: modifiedAdresseEmails.length + 1,
      id: null,
      types_email_id: null,
      email: null,
    });
    setFormAdresseEmails(modifiedAdresseEmails);
  };

  const onDeleteFormAdresseEmail = (id) => {
    var modifiedAdresseEmails = [...formAdresseEmails];
    modifiedAdresseEmails = modifiedAdresseEmails.filter(
      (x) => x["index"] !== id
    );
    setFormAdresseEmails(modifiedAdresseEmails);
  };
  const handleInputChangeEmail = (id, field, value) => {
    console.log("ID:", id);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedAdresseEmails = formAdresseEmails.map((adresseEmail) => {
      if (adresseEmail.index === id) {
        return {
          ...adresseEmail,
          [field]: value,
        };
      }
      return adresseEmail;
    });

    setFormAdresseEmails(modifiedAdresseEmails);
  };
  console.log("Adresse Email", formAdresseEmails);
  /******************************* END HMF adresses emails *******************************************/
  /******************************* HMF adresses telephone *******************************************/
  const [formNumeroTelephones, setFormNumeroTelephones] = useState({});

  const onAddFormNumeroTelephone = () => {
    const modifiedNumeroTelephones = [...formNumeroTelephones];
    modifiedNumeroTelephones.push({
      index: modifiedNumeroTelephones.length + 1,
      id: null,
      types_telephone_id: null,
      numero: null,
    });
    setFormNumeroTelephones(modifiedNumeroTelephones);
  };

  const onDeleteFormNumeroTelephone = (id) => {
    var modifiedNumeroTelephones = [...formNumeroTelephones];
    modifiedNumeroTelephones = modifiedNumeroTelephones.filter(
      (x) => x["index"] !== id
    );
    setFormNumeroTelephones(modifiedNumeroTelephones);
  };
  const handleInputChangeTelephone = (id, field, value) => {
    console.log("ID:", id);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedNumeroTelephones = formNumeroTelephones.map((numeroTel) => {
      if (numeroTel.index === id) {
        return {
          ...numeroTel,
          [field]: value,
        };
      }
      return numeroTel;
    });

    setFormNumeroTelephones(modifiedNumeroTelephones);
  };
  /******************************* END HMF adresses telephone *******************************************/
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmitPP = async (event) => {
    event.preventDefault();
    if (nom === "" && selectedStatut === null) {
      toast.error("Le statut et le nom ne peuvent pas être vide");
    } else if (nom === "") {
      toast.error("Le nom ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investisseur: {
                id: id,
                statut_investisseur_id: selectedStatut?.value || "",
                partenaire_id: selectedConseil?.value || "",
                courrier: selectedCourrier ? 1 : 2,
                commentaires: comments,
              },
              contact: {
                nom: nom,
                prenom: prenom,
                societe_id: selectedSociete?.value || "",
                titre_id: selectedTitre?.value || "",
                date_de_naissance: dateNaissance,
                ville_de_naissance: villeNaissance,
                departement_ou_pays: depNaissance,
                profession: profession,
                situation_matrimoniale_id:
                  selectedSituationMatrimoniale?.value || "",
              },
              contact_hmf_adresses: formAdressePostals.map((obj) => {
                // on retire le champs index
                delete obj.index;
                return obj;
              }),
              contact_hmf_emails: formAdresseEmails.map((obj) => {
                delete obj.index;
                return obj;
              }),
              contact_hmf_telephones: formNumeroTelephones.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (
            (responseData && responseData.contact_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors =
              responseData?.contact_validation ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleSubmitPM = async (event) => {
    event.preventDefault();
    if (denomSocial === "" && selectedStatut === null) {
      toast.error(
        "Le statut et la dénomination sociale ne peuvent pas être vide"
      );
    } else if (denomSocial === "") {
      toast.error("La dénomination sociale ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investisseur: {
                id: id,
                statut_investisseur_id: selectedStatut?.value || "",
                partenaire_id: selectedConseil?.value || "",
                courrier: selectedCourrier ? 1 : 2,
                commentaires: comments,
                rcs: numeroRcs,
              },
              societe: {
                raison_sociale: denomSocial,
                telephone: telephone,
                fax: fax,
                email: emailPm,
                formes_juridique_id: selectedForme?.value || "",
                societe_id: selectedPresidentPM?.value || "", // Président PM
                contact2_id: selectedDir?.value || selectedDir?.id || "", // directeur
                contact_id:
                  selectedPresidentPP?.value || selectedPresidentPP?.id || "", // Président PP
              },
              societe_hmf_adresses: formAdressePostals.map((obj) => {
                // on retire le champs index
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");

          handleNavigate({ key: true });
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Submit Edit *******************************************/
  /******************************* Validation *******************************************/
  const validationSchema = Yup.object().shape({
    selectedStatut: Yup.string().required("Veuillez sélectionner un statut"),
  });
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        // commun
        await getData();
        await getStatut();
        await getConseil();
        await getPay();
        // if PP
        await getTitre();
        await getSociete();
        await getCsp();
        await getSituationMatrimoniale();
        await getTypesAdress();
        await getTypesTelephone();
        await getTypesEmail();
        // if PM
        await getFormeJuri();
        await getPresident();
        await getDirecteur();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
      console.log("test finished");
    }
  }, [wait]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investisseurs | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails investisseur
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={navStyle}
            to="#contact"
            onClick={() => handleTabClick("contact")}
            className={`nav-link ${activeTab === "contact" ? "active" : ""}`}
          >
            {!loading ? (
              investisseursData?.detail_investisseur?.identification.Type ==
              "PP" ? (
                "Détails personne physique"
              ) : (
                "Détails personne morale"
              )
            ) : (
              <>
                <h5 className="card-title placeholder-glow">
                  <span
                    style={{ height: "1em" }}
                    className="placeholder col-6"
                  ></span>
                </h5>
              </>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const renderValue = (value) => {
    if (value == null) {
      return "";
    } else if (typeof value === "string" && value.trim() === "") {
      return "";
    } else if (value === "Validé") {
      return <span className="bg-success badge bg-secondary">{value}</span>;
    } else if (value === "En attente") {
      return <span className="bg-info badge bg-secondary">{value}</span>;
    } else {
      return value;
    }
  };

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#3c88c8",
                          textDecoration: "underline !important",
                        }}
                      >
                        Investisseurs
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investisseursData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>
                  {!loading &&
                  investisseursData?.detail_investisseur?.identification.Type ==
                    "PP" ? (
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-info"
                          onClick={handleSubmitPP} // validation PP
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-info"
                          onClick={handleSubmitPM} // validation PM
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  )}
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  {" "}
                                  Identification
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_investisseur
                                      ?.identification
                                  ).map(([key, value], index) => (
                                    <Row className="mb-3" key={index}>
                                      {key === "Statut" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key}* :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <Select
                                              value={selectedStatut}
                                              onChange={handleStatutChange}
                                              options={renderStatutOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                            {selectedStatut === null ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Statut ne peut pas être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </>
                                      ) : key === "Courrier" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="mb-2 col-md-8"
                                          >
                                            <Switch
                                              uncheckedIcon={<Offsymbol />}
                                              checkedIcon={<OnSymbol />}
                                              onColor="#3C88c8"
                                              onChange={() => {
                                                setSelectedCourrier(
                                                  !selectedCourrier
                                                );
                                              }}
                                              checked={
                                                selectedCourrier == 1
                                                  ? true
                                                  : false
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Partenaire" ? (
                                        <>
                                          <Col
                                            className="col-md-4 mb-2"
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="mb-2 col-md-8">
                                            <Select
                                              isDisabled={true}
                                              defaultValue={selectedConseil}
                                              onChange={handleConseilChange}
                                              options={renderConseilOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="mb-2 col-md-8"
                                          >
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <SouscriptionsCard
                                  title="Souscriptions"
                                  details={
                                    investisseursData?.detail_investisseur
                                      ?.souscriptions
                                  }
                                />
                              </Row>
                              <Row>
                                <Card className="mb-4">
                                  <CardTitle tag="h5">Détails</CardTitle>
                                  <CardBody>
                                    <Row className="mb-3">
                                      <Col
                                        key="commentaires"
                                        className="col-4"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "11em",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Commentaires :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={8}
                                        className="mb-2 col-md-8"
                                      >
                                        <textarea
                                          className="form-control"
                                          defaultValue={
                                            investisseursData
                                              ?.detail_investisseur?.details
                                              .Commentaires
                                          }
                                          style={{
                                            width: "100%",
                                            resize: "vertical",
                                          }}
                                          onChange={(e) =>
                                            setComments(e.target.value)
                                          }
                                        ></textarea>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "contact" && (
                    <div>
                      {!loading &&
                      investisseursData?.detail_investisseur?.identification
                        .Type == "PP" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Identification
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.identification
                                  ).map(([key, value], index) => (
                                    <Row className="mb-3" key={index}>
                                      {key === "Titre" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            className="col-md-4 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <Select
                                              value={selectedTitre}
                                              onChange={handleTitreChange}
                                              options={renderTitreOptions()}
                                              isClearable={true}
                                              className="select2"
                                              isSearchable={false}
                                              placeholder="Titre"
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Société" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            className="col-md-4 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <Select
                                              value={selectedSociete}
                                              onChange={handleSocieteChange}
                                              options={renderSocieteOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Nom" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            className="col-md-4 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key}* :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <input
                                              className="form-control"
                                              defaultValue={nom}
                                              required
                                              onChange={(e) =>
                                                setNom(e.target.value)
                                              }
                                            />
                                            {nom === "" ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Nom ne peut pas être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </>
                                      ) : key === "Prénom" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            className="col-md-4 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <input
                                              className="form-control"
                                              defaultValue={prenom}
                                              onChange={(e) =>
                                                setPrenom(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            className="col-md-4 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Renseignements Divers
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.renseignements_divers
                                  ).map(([key, value], index) => (
                                    <Row className="mb-3" key={index}>
                                      {key === "Date de naissance" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={{
                                              width: "15em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={6}
                                            className="mb-2 col-md-8"
                                          >
                                            <InputMask
                                              mask="99/99/9999"
                                              value={dateNaissance}
                                              className="form-control input-color"
                                              onChange={(dateString) => {
                                                setDateNaissance(
                                                  dateString.target.value
                                                );
                                              }}
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Ville de naissance" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={{
                                              width: "15em",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={6}>
                                            <input
                                              className="form-control"
                                              defaultValue={villeNaissance}
                                              onChange={(e) =>
                                                setVilleNaissance(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Département de naissance" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={{
                                              width: "15em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={6}>
                                            <input
                                              className="form-control"
                                              defaultValue={depNaissance}
                                              onChange={(e) =>
                                                setDepNaissance(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Profession" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={{
                                              width: "15em",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={6}>
                                            <input
                                              className="form-control"
                                              defaultValue={profession}
                                              onChange={(e) =>
                                                setProfession(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "CSP" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <select
                                              value={selectedCsp}
                                              onChange={handleCspChange}
                                              style={{ maxWidth: "200px" }}
                                            >
                                              {renderCspOptions()}
                                            </select>
                                          </Col>
                                        </>
                                      ) : key === "Situation matrimoniale" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            className="col-md-4 mb-2"
                                            style={{
                                              width: "15em",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={6}
                                            className="mb-2 col-md-8"
                                          >
                                            <Select
                                              value={
                                                selectedSituationMatrimoniale
                                              }
                                              onChange={
                                                handleSituationMatrimonialeChange
                                              }
                                              options={renderSituationMatrimonialeOptions()}
                                              isClearable={true}
                                              className="select2"
                                              isSearchable={false}
                                              placeholder="Titre"
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            className="col-md-4 mb-2"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            className="mb-2 col-md-8"
                                          >
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Card className="mb-4">
                              <CardTitle tag="h5">Adresses</CardTitle>
                              <CardBody>
                                <Col sm="12">
                                  <div className="table-responsive">
                                    <table
                                      className="table table-bordered rounded-3 overflow-hidden"
                                      style={{
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          {investisseursData?.detail_nom_investisseur?.adresses_postales?.Adresses.header.map(
                                            (columnName, index) => (
                                              <th
                                                className="text-nowrap"
                                                style={tableaustyles}
                                                key={index}
                                              >
                                                {columnName}
                                              </th>
                                            )
                                          )}
                                          <th
                                            className="text-nowrap"
                                            style={{
                                              background: "#3c88c8",
                                              color: "white",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              width: "1%",
                                            }}
                                            key="Del"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formAdressePostals.map((rowData) => (
                                          <tr key={rowData.index}>
                                            {Object.entries(rowData).map(
                                              ([key, value]) =>
                                                key !== "id" &&
                                                key !== "index" ? (
                                                  <td key={key}>
                                                    {key === "principale" ? (
                                                      <select
                                                        defaultValue={value}
                                                        name="principale"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderYesNoOptions()}
                                                      </select>
                                                    ) : key ===
                                                      "types_adress_id" ? (
                                                      <select
                                                        defaultValue={value}
                                                        name="types_adress_id"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      >
                                                        {renderTypesAdressOptions()}
                                                      </select>
                                                    ) : key === "adresse" ||
                                                      key === "complement" ||
                                                      key === "code_postal" ||
                                                      key === "ville" ||
                                                      key === "tel_fixe" ? (
                                                      <input
                                                        className="form-control form-control-sm"
                                                        defaultValue={value}
                                                        name={key}
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : key === "pay_id" ? (
                                                      <select
                                                        defaultValue={value}
                                                        name="pay_id"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderPayOptions()}
                                                      </select>
                                                    ) : (
                                                      <span>{value}</span>
                                                    )}
                                                  </td>
                                                ) : (
                                                  <td
                                                    className="d-none"
                                                    key={key}
                                                  >
                                                    <input
                                                      type="hidden"
                                                      value={value}
                                                    />
                                                  </td>
                                                )
                                            )}
                                            <td>
                                              <i
                                                className="bx bx-trash"
                                                style={{
                                                  fontSize: "20px",
                                                  paddingTop: "5px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  onDeleteFormAdressePostal(
                                                    rowData.index
                                                  )
                                                }
                                              ></i>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td colSpan="9">
                                            <input
                                              type="button"
                                              style={tableaustyles}
                                              className="btn btn-info mt-3 mt-lg-0"
                                              value="Ajouter"
                                              onClick={onAddFormAdressePostal}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </Col>
                              </CardBody>
                            </Card>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Emails
                                </CardTitle>

                                <CardBody>
                                  <div className="table-responsive">
                                    <table className="table table-bordered rounded-3 overflow-hidden">
                                      <thead>
                                        <tr>
                                          {investisseursData?.detail_nom_investisseur?.adresses_email?.Emails.header.map(
                                            (columnName, index) => (
                                              <th
                                                className="text-nowrap"
                                                style={tableaustyles}
                                                key={index}
                                              >
                                                {columnName}
                                              </th>
                                            )
                                          )}
                                          <th
                                            className="text-nowrap"
                                            style={{
                                              background: "#3c88c8",
                                              color: "white",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              width: "5%",
                                            }}
                                            key="Del"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formAdresseEmails.map((rowData) => (
                                          <tr key={rowData.index}>
                                            {Object.entries(rowData).map(
                                              ([key, value]) =>
                                                key !== "id" &&
                                                key !== "index" ? (
                                                  <td key={key}>
                                                    {key ===
                                                    "types_email_id" ? (
                                                      <select
                                                        defaultValue={value}
                                                        name="types_email_id"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChangeEmail(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderTypesEmailOptions()}
                                                      </select>
                                                    ) : key === "email" ? (
                                                      <input
                                                        className="form-control form-control-sm"
                                                        defaultValue={value}
                                                        name="email"
                                                        onChange={(e) =>
                                                          handleInputChangeEmail(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <span>{value}</span>
                                                    )}
                                                  </td>
                                                ) : (
                                                  <td
                                                    className="d-none"
                                                    key={key}
                                                  >
                                                    <input
                                                      type="hidden"
                                                      size="10"
                                                      value={value}
                                                    />
                                                  </td>
                                                )
                                            )}
                                            <td>
                                              <i
                                                className="bx bx-trash"
                                                style={{
                                                  fontSize: "20px",
                                                  paddingTop: "5px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  onDeleteFormAdresseEmail(
                                                    rowData.index
                                                  )
                                                }
                                              ></i>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td colSpan="9">
                                            <input
                                              type="button"
                                              style={tableaustyles}
                                              className="btn btn-info mt-3 mt-lg-0"
                                              value="Ajouter"
                                              onClick={onAddFormAdresseEmail}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Numéros
                                </CardTitle>
                                <CardBody>
                                  <div className="table-responsive">
                                    <table className="table table-bordered rounded-3 overflow-hidden">
                                      <thead>
                                        <tr>
                                          {investisseursData?.detail_nom_investisseur?.numeros_de_telephone?.Téléphones.header.map(
                                            (columnName, index) => (
                                              <th
                                                className="text-nowrap"
                                                style={tableaustyles}
                                                key={index}
                                              >
                                                {columnName}
                                              </th>
                                            )
                                          )}
                                          <th
                                            className="text-nowrap"
                                            style={{
                                              background: "#3c88c8",
                                              color: "white",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              width: "5%",
                                            }}
                                            key="Del"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formNumeroTelephones.map((rowData) => (
                                          <tr key={rowData.index}>
                                            {Object.entries(rowData).map(
                                              ([key, value]) =>
                                                key !== "id" &&
                                                key !== "index" ? (
                                                  <td key={key}>
                                                    {key ===
                                                    "types_telephone_id" ? (
                                                      <select
                                                        defaultValue={value}
                                                        name="types_telephone_id"
                                                        onChange={(e) =>
                                                          handleInputChangeTelephone(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      >
                                                        {renderTypesTelephoneOptions()}
                                                      </select>
                                                    ) : key === "numero" ? (
                                                      <input
                                                        className="form-control form-control-sm"
                                                        defaultValue={value}
                                                        name="numero"
                                                        onChange={(e) =>
                                                          handleInputChangeTelephone(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <span>{value}</span>
                                                    )}
                                                  </td>
                                                ) : (
                                                  <td
                                                    className="d-none"
                                                    key={key}
                                                  >
                                                    <input
                                                      type="hidden"
                                                      size="10"
                                                      value={value}
                                                    />
                                                  </td>
                                                )
                                            )}
                                            <td>
                                              <i
                                                className="bx bx-trash"
                                                style={{
                                                  fontSize: "20px",
                                                  paddingTop: "5px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  onDeleteFormNumeroTelephone(
                                                    rowData.index
                                                  )
                                                }
                                              ></i>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td colSpan="9">
                                            <input
                                              type="button"
                                              style={tableaustyles}
                                              className="btn btn-info mt-3 mt-lg-0"
                                              value="Ajouter"
                                              onClick={onAddFormNumeroTelephone}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      ) : // Si le type est égal à PM (Personne morale)
                      !loading &&
                        investisseursData?.detail_investisseur?.identification
                          .Type == "PM" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Identification
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.identification
                                  ).map(([key, value], index) => (
                                    <Row className="mb-3">
                                      {key === "Dénomination sociale" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "wrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingRight: "20px",
                                                  whiteSpace: "wrap",
                                                }}
                                              >
                                                {key}* :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={denomSocial}
                                              onChange={(e) =>
                                                setDenomSocial(e.target.value)
                                              }
                                            />
                                            {denomSocial === "" ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Dénomination sociale ne peut pas
                                                être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </>
                                      ) : key === "N° RCS" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={numeroRcs}
                                              onChange={(e) =>
                                                setNumeroRcs(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Contact
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.contact
                                  ).map(([key, value], index) => (
                                    <Row className="mb-3">
                                      {key === "Téléphone" ? (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={telephone}
                                              onChange={(e) =>
                                                setTelephone(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Fax" ? (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={fax}
                                              onChange={(e) =>
                                                setFax(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Email" ? (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={emailPm}
                                              onChange={(e) =>
                                                setEmailPm(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Caractéristique
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.caracteristiques
                                  ).map(([key, value], index) => (
                                    <Row className="mb-3">
                                      {key === "Forme juridique" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={8}>
                                            <Select
                                              defaultValue={selectedForme}
                                              onChange={handleFormeChange}
                                              options={renderFormeOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : // Président
                                      key === "Président (PM)" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={8}>
                                            <Select
                                              defaultValue={selectedPresidentPM}
                                              onChange={handlePresidentChange}
                                              options={renderPresidentOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Directeur Général" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={8}>
                                            {/* Rendre les options directeurs */}
                                            <Select
                                              value={selectedDir}
                                              onChange={handleDirecteurChange}
                                              options={renderDirecteurOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Président (PP)" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={8}>
                                            {/* Rendre les options directeurs */}
                                            <Select
                                              value={selectedPresidentPP}
                                              onChange={handlePresidentPPChange}
                                              options={renderDirecteurOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                }}
                                              >
                                                {key} :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="12">
                              <CardTitle
                                tag="h5"
                                style={{ paddingBottom: "10px" }}
                              >
                                Adresses
                              </CardTitle>
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      {investisseursData?.detail_nom_investisseur?.adresses?.Adresses.header.map(
                                        (columnName, index) => (
                                          <th
                                            className="text-nowrap"
                                            style={tableaustyles}
                                            key={index}
                                          >
                                            {columnName}
                                          </th>
                                        )
                                      )}
                                      <th
                                        className="text-nowrap"
                                        style={tableaustyles}
                                        key="Del"
                                      ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formAdressePostals.map(
                                      (rowData, index) => (
                                        <tr key={index}>
                                          {Object.entries(rowData).map(
                                            ([key, value]) =>
                                              key !== "id" &&
                                              key !== "index" ? (
                                                <td key={key}>
                                                  {key === "siege" ? (
                                                    <div>
                                                      <select
                                                        className="form-control form-control-sm"
                                                        style={{
                                                          minWidth: "50px",
                                                        }}
                                                        defaultValue={value}
                                                        name="siege"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderYesNoOptions()}
                                                      </select>
                                                      {value === "" ? (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          Siège ne peut pas être
                                                          vide
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  ) : key === "adresse" ||
                                                    key === "complement" ||
                                                    key === "code_postal" ||
                                                    key === "ville" ||
                                                    key === "pay_id" ||
                                                    key === "tel" ? (
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{
                                                        minWidth:
                                                          key === "adresse"
                                                            ? "150px"
                                                            : "50px",
                                                      }}
                                                      defaultValue={value}
                                                      name={key}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          rowData.index,
                                                          e.target.name,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                              ) : (
                                                <td
                                                  key={key}
                                                  className="d-none"
                                                >
                                                  <input
                                                    type="hidden"
                                                    size="10"
                                                    value={value}
                                                  />
                                                </td>
                                              )
                                          )}
                                          <td>
                                            <i
                                              className="bx bx-trash"
                                              style={{
                                                fontSize: "20px",
                                                paddingTop: "5px",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                onDeleteFormAdressePostalPM(
                                                  rowData.index
                                                )
                                              }
                                            ></i>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                    <tr>
                                      <td colSpan="9">
                                        <input
                                          type="button"
                                          style={tableaustyles}
                                          className="btn btn-info mt-3 mt-lg-0"
                                          value="Ajouter"
                                          onClick={onAddFormAdressePostalPM}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default InvestorDetail;
